import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProgram, updateProgram } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProgramEditPage() {
  const { businessDomainId, businessUnitId, programId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/programs/${programId}`;

  const [form, setForm] = useState({ programId: "", companyId: "", businessUnitId: "", programName: "", programDescription: "" });

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchProgram(programId);
        setForm({
          programId: d.programId || "",
          companyId: d.companyId || "",
          businessUnitId: d.businessUnitId || businessUnitId,
          programName: d.programName || "",
          programDescription: d.programDescription || "",
        });
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateProgram(form);
      notify.success(t("message.update.success"));
      navigate(basePath);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("program.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}><TextField fullWidth required label={t("program.name")} name="programName" value={form.programName} onChange={handleChange} /></Grid>
          <Grid size={12}><TextField fullWidth multiline rows={2} label={t("program.description")} name="programDescription" value={form.programDescription} onChange={handleChange} /></Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/programs/${programId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
